// We add a class name "hovered" to the list items when the mouse enters and remove it when
// the mouse leaves or when clicked
// Handle hover effects for all list items
const listItems = document.querySelectorAll('li.hover-effect');

listItems.forEach(function(item) {
  item.addEventListener('mouseenter', function() {
    item.classList.add('hovered');
  });

  item.addEventListener('mouseleave', function() {
    item.classList.remove('hovered');
  });

  item.addEventListener('click', function() {
    item.classList.remove('hovered');
  });
});

// Handle opening and closing <details> for menu list items
const listItemsmenu = document.querySelectorAll('.list-menu li.hover-effect'); 

listItemsmenu.forEach(function(item) {
  item.addEventListener('mouseenter', function() {
    const detailsElement = item.querySelector('details');
    if (detailsElement) {
      detailsElement.setAttribute('open', 'true'); 
      item.classList.add('hovered');
    }
  });

  item.addEventListener('mouseleave', function() {
    const detailsElement = item.querySelector('details');
    if (detailsElement) {
      detailsElement.removeAttribute('open'); 
      item.classList.remove('hovered');
    }
  });
});


